var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5296521_play_video_vlog_youtube_youtube logo_icon 3",
    clipPath: "url(#clip0_0_3716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.373 7.7792C29.028 6.48838 28.0116 5.47195 26.7208 5.12701C24.381 4.5 14.9999 4.5 14.9999 4.5C14.9999 4.5 5.61873 4.5 3.27891 5.12701C1.98838 5.47195 0.971719 6.48838 0.626719 7.7792C0 10.1187 0 15.0001 0 15.0001C0 15.0001 0 19.8814 0.626719 22.2207C0.971719 23.5115 1.98838 24.5282 3.27891 24.8731C5.61873 25.4999 14.9999 25.4999 14.9999 25.4999C14.9999 25.4999 24.381 25.4999 26.7208 24.8731C28.0116 24.5282 29.028 23.5115 29.373 22.2207C30 19.8814 30 15.0001 30 15.0001C30 15.0001 30 10.1187 29.373 7.7792Z",
    fill: "#ED1F24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 19.5001L19.794 15.0001L12 10.5V19.5001Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4711de2a611158a875eba3eb5a985062.svg";
export { ForwardRef as ReactComponent };